<template>
  <InputComponent
    class="field-color-selector"
    :class="{ 'field-color-selector--empty': !comp }"
    v-bind="$attrs"
    :icon="['fal', 'palette']"
  >
    <template #default>
      <input
        class="elder-input__element"
        type="color"
        v-model="comp"
        :style="{ height: `${height}px` }"
      />
    </template>
  </InputComponent>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import { ValueComp } from '../utils'

export default {
  props: ['value', 'default'],
  data() {
    return {
      height: 75,
    }
  },
  created() {
    if ('default' in this.$options.propsData && this.value === undefined) this.comp = this.default
  },
  computed: {
    comp: ValueComp(),
  },
  components: {
    InputComponent,
  },
}
</script>

<style lang="scss">
.field-color-selector {
  .elder-input__wrapper {
    align-items: center;
  }

  &--empty {
    input {
      max-height: 30px !important;
      overflow: hidden;
      position: relative;
      margin: 1.5em;
      border: 1px solid black;
      padding: 0;

      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;

        /* Rising diagonal line */
        background: linear-gradient(
          to right bottom,
          white 0%,
          white 49%,
          red 50%,
          red 51%,
          white 52%,
          white
        );
      }
    }
  }
}
</style>
